import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const Heading = styled.h2`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: clamp(30px, 3.6vw, 46px);
  line-height: 1.1;
  letter-spacing: -0.015em;
  margin: 0 0 40px;
  color: ${colors.textPrimary};
`;

export const List = styled.div`
  display: grid;
  gap: 12px;
`;

export const Item = styled.div`
  border-radius: 24px;
  border: 1px solid ${colors.border};
  background: ${colors.surface};
  overflow: hidden;
`;

export const Question = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 26px;

  background: transparent;
  border: 0;

  font-family: ${typography.displayFontFamily};
  font-weight: 600;
  font-size: 17px;
  color: ${colors.textPrimary};
  text-align: left;
  cursor: pointer;
`;

export const Sign = styled.span`
  color: ${colors.primary};
  font-size: 20px;
  flex: none;
`;

export const Answer = styled.div<{ open: boolean }>`
  display: grid;
  grid-template-rows: ${props => (props.open ? '1fr' : '0fr')};
  transition: grid-template-rows 280ms ease;

  p {
    margin: 0;
    padding: 0 26px 22px;
    overflow: hidden;
    /* Item de grid tem min-height:auto por padrão, que ignora o track
       0fr e nunca deixa colapsar de verdade -- sem isso a resposta
       ficava sempre visível, mesmo com o item fechado. */
    min-height: 0;
    font-size: 16px;
    line-height: 1.65;
    color: ${colors.textSecondary};
  }
`;
